// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProductTypeConfigProduct } from './product-type-config-product';
import { SupplierAccount } from './supplier-account';
import { SupplierAdmin } from './supplier-admin';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SupplierInventoryApproval extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK approvedBySupplierAdmin */
  approvedBySupplierAdminId?: string;
  /** DateTime */
  approvedDate!: Date;
  /** String(500) */
  notes?: string;
  /** Guid FK productTypeConfigProduct */
  productTypeConfigProductId!: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplierAccount */
  supplierAccountId!: string;
  /** FK approvedBySupplierAdminId */
  approvedBySupplierAdmin!: SupplierAdmin;
  /** FK productTypeConfigProductId */
  productTypeConfigProduct!: ProductTypeConfigProduct;
  /** FK supplierAccountId */
  supplierAccount!: SupplierAccount;
}

